import { ALK_ROLES } from '../../../models/alk-roles';
import { PARTNER_ROLES } from '../../../models/partner-roles';
import { composeRoles } from '../../../utils/compose-roles';

export const hasPartnerRole = composeRoles(ALK_ROLES, PARTNER_ROLES);
